import { BankConnection } from '@core/model/domain/bankConnection';
import { Ok } from '@core/model/framework/Result/OkResult';
import {
  AuthenticateToBankWithCredentialsServiceOutput,
  BankService,
  GetBankByIdServiceInput,
  GetBankByIdServiceOutput,
  GetBankConnectionServiceOutput,
  GetBankConnectionsServiceOutput,
  GetWebauthJourneyStatusServiceInput,
  GetWebauthJourneyStatusServiceOutput,
} from '@core/model/service/bankService';
import { GetBanksOutput } from '@core/usecase/getBanks';
import { GetWebauthUrlInput, GetWebauthUrlOutput } from '@core/usecase/getWebauthUrl';
import {
  SaveWebauthBankConnectionInput,
  SaveWebauthBankConnectionOutput,
} from '@core/usecase/saveWebauthBankConnection';
import { injectable } from 'inversify';

@injectable()
export class IMBankService implements BankService {
  getBankById(_input: GetBankByIdServiceInput): GetBankByIdServiceOutput {
    throw new Error('Method not implemented.');
  }
  authenticateWithCredentials(): AuthenticateToBankWithCredentialsServiceOutput {
    throw new Error('Method not implemented.');
  }
  getBankConnections(): GetBankConnectionsServiceOutput {
    throw new Error('Method not implemented.');
  }
  getBankConnection(): GetBankConnectionServiceOutput {
    throw new Error('Method not implemented.');
  }
  getWebauthUrl(_input: GetWebauthUrlInput): GetWebauthUrlOutput {
    throw new Error('Method not implemented.');
  }
  getWebauthJourneyStatus(_input: GetWebauthJourneyStatusServiceInput): GetWebauthJourneyStatusServiceOutput {
    throw new Error('Method not implemented.');
  }
  getBanks(): GetBanksOutput {
    throw new Error('Method not implemented.');
  }
  async saveWebauthBankConnection(input: SaveWebauthBankConnectionInput): SaveWebauthBankConnectionOutput {
    if (input.webauthPopupUserToken !== 'OK') {
      throw new Error('');
    }
    return Ok({} as BankConnection);
  }
}
